








































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import Tips from "@/components/common/index/Tips.vue";
import Modal from "@/components/common/index/Modal.vue";
import Validate from "@/mixins/validate";
import getUrlParam from "@/common/utils/getUrlParam";
import { formatDecimal } from "@/common/utils/format";
import VaidateCondition from "@/mixins/validateCondition";
import DashLine from "@/components/common/edit/DashLine.vue";

import { Tip } from "@/common/interface";
import { Ladder } from "@/common/interface/group_type";
import { Solitaire } from "@/common/interface/solitaire_type";
import { majorNoticeText } from "@/common/constants/index";

const validateCondition = VaidateCondition();
const solitaireTips = {
  title: "接龙方案",
  content: `<p>1、群接龙最多可设置5组价格梯度，参与接龙人数越多，则对应价格越低。<span style="color: #FE0240">为有效锁定线索，避免无效用户报名。建议相邻梯度间优惠价格差<=300</span></p>
          <p> 2、接龙模式下，若需开启支付功能，则仅支持“定金”支付</p>`,
};

@Component({
  components: {
    tips: Tips,
    "dash-line": DashLine,
  },
})
export default class SolitaireProgram extends Vue {
  @Getter("solitaireList") solitaireList!: Solitaire[];
  @Getter("canPay") canPay!: boolean;
  @Getter("payType") payType!: string;
  @Getter("section") section: any;
  @Getter("xcxFlag") xcxFlag!: boolean;
  @Getter("xmMajordomo") xmMajordomo!: string;
  @Getter("xcxType") xcxType!: string;

  @Action("changePayType") changePayType!: Function;
  @Action("changeLadderGroup") changeLadderGroup!: Function;
  @Action("changeSectionInfo") changeSectionInfo!: Function;

  solitaireTips: Tip = solitaireTips;
  getUrlParam: Function = getUrlParam;

  get disabled() {
    return this.getUrlParam("type") === "reEdit";
  }

  handleChangeSolitaireSize(solitaire: Solitaire) {
    const { size } = solitaire;
    solitaire.size = Math.floor(Number(size));
    return solitaire.size;
  }

  changeCourseInfo(event: Event, type: string) {
    const payload = {
      value: (event.target as HTMLInputElement).value,
      type,
    };
    this.changeSectionInfo(payload);
  }
  // 添加拼团方案
  handleAddSolitaire() {
    if (this.xcxType === "mkb") {
      return;
    }
    // 普通用户不支持
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: "提示",
        text: majorNoticeText,
        okText: "确定",
      });
      return;
    }
    // 再编辑状态不可点击
    if (this.disabled) return;
    // 新增一个拼团方案
    this.solitaireList.push({
      size: "",
      price: "",
    });
    this.changeLadderGroup(this.solitaireList);
  }

  // 删除拼团方案
  handleDeleteSolitaire(index: number) {
    this.solitaireList.splice(index, 1);
    this.changeLadderGroup(this.solitaireList);
  }
}
